import opinion from './opinion.vue'
export default opinion